/* eslint-disable import/no-anonymous-default-export */
import request from '@hho-middle/network'

export default {
  // 获取验证码
  captcha: () => request('/base/captcha').post(),
  login: data => request('/base/login').post({data}),
  ddLogin: data => request('/base/DingdingLogin').post({data}),
}
